/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Container, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { DEAL_NOTIFICATION_TYPES } from './data';
import CompleteDealNotification from './CompleteDealNotification';
import AssigneeNotification from './AssigneeNotification';

const EmailNotificationSettings = () => {
	const email = useSelector((state) => state.msalAccount.account?.username);
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });

	const canViewDealNotifications = userDetails?.principleUser || userDetails?.complianceManager;

	return (
		<Container>
			<Stack spacing={2}>
				<Typography variant='form_label' fontSize='16px'>
					Email notifications
				</Typography>
				<Typography variant='body2' color='text.secondary'>
					Assignment and completion events also appear as in-app notifications in the
					bell icon at the top of the page. Email preferences below only control email
					delivery.
				</Typography>
				<Stack spacing={2}>
					<AssigneeNotification type='task' label='Task' />
					{canViewDealNotifications && (
						<>
							{DEAL_NOTIFICATION_TYPES.map((type) => {
								const label =
									type.charAt(0).toUpperCase() + type.substring(1).toLowerCase();
								return <CompleteDealNotification key={type} {...{ type, label }} />;
							})}
						</>
					)}
				</Stack>
			</Stack>
		</Container>
	);
};

export default EmailNotificationSettings;
